import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';

export default function NoResults({ noResultsSettings, results }: componentTypes.NoResultsProps) {
  return (
    <div className="hits-empty-state hits-empty-state--with-border">
      <p className="hits-empty-state__title">
        {results.query
          ? (noResultsSettings.translations?.query || 'Sorry, we can\'t find any matches to your query!').replace('{query}', results.query)
          : (noResultsSettings.translations?.noResults || 'Sorry, we can\'t find any matches to your query!')}
      </p>
    </div>
  );
}
